import _ from 'lodash';
import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StopMarker from './marker';
import DraggableStop from './draggable_stop';

export default class StopMarkers extends Component {
  constructor(props) {
    super(props);
    this.state = { };
    this.onSidebarShow = this.onSidebarShow.bind(this);
    this.onMarkerAdded = this.onMarkerAdded.bind(this);
  }

  componentDidMount() {
    $(document).off('gm:sidebar:show.stops').on('gm:sidebar:show.stops', this.onSidebarShow.bind(this));
  }

  componentWillReceiveProps() {
    if (!$('form#new_stop').length) {
      this.setState({ newStopMarkerPosition: null });
    }
  }

  componentWillUnmount() {
    $(document).off('gm:sidebar:show.stops');
  }

  onMarkerAdded(latLng) {
    this.setState({ newStopMarkerPosition: { lat: latLng.lat(), lng: latLng.lng() } });
  }

  onSidebarShow() {
    const $draggableStop = $('#draggable-stop');
    if (!$draggableStop.length) { return; }

    ReactDOM.render(
      <DraggableStop overlayView={this.props.overlayView} onMarkerAdded={this.onMarkerAdded} />,
      $draggableStop[0],
    );
  }

  updateKinds() {
    this.setState({ kinds: _.map($('.stop-filter:checked'), el => $(el).data('value')) });
  }

  render() {
    const { stops, stoppableAddresses, selectedId, onClick } = this.props;
    const newStop = this.state && this.state.newStopMarkerPosition ? (
      <StopMarker
        key="new"
        stop={_.extend({ kind: 'scholar' }, this.state.newStopMarkerPosition)}
        selected
        onClick={onClick}
      />
    ) : null;
    return (
      <div>
        {_(stops)
          .filter(stop => _.includes(this.props.kinds, stop.kind))
          .map(stop => (
            <StopMarker
              key={stop.id}
              stop={stop}
              stoppableAddresses={_.filter(stoppableAddresses, { stoppable_id: stop.id, stoppable_type: 'Stop' })}
              selected={selectedId === stop.id}
              onClick={onClick}
            />))
          .value()}
        {newStop}
      </div>
    );
  }
}

StopMarkers.defaultProps = {
  selectedId: null,
  overlayView: null,
  stops: [],
  stoppableAddresses: [],
  kinds: ['scholar', 'public_transport'],
};

StopMarkers.propTypes = {
  stops: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  })),
  stoppableAddresses: PropTypes.arrayOf(PropTypes.shape({
    stoppable_id: PropTypes.number.isRequired,
    stoppable_type: PropTypes.oneOf(['Stop', 'School']).isRequired,
    address_id: PropTypes.number.isRequired,
  })),
  selectedId: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  overlayView: PropTypes.instanceOf(google.maps.OverlayView),
  kinds: PropTypes.arrayOf(PropTypes.string),
};
